import Form from "react-bootstrap/Form";
import "./contactUs.css";
import Button from "react-bootstrap/Button";
import React from "react";
import 'bootstrap/dist/css/bootstrap.css';
import emailjs from '@emailjs/browser';

const SERVICE_ID = process.env.REACT_APP_SERVICEID;
const TEMPLATE_ID = process.env.REACT_APP_TEMPLATEID;
const USER_ID = process.env.REACT_APP_USERID;

emailjs.init(USER_ID);

const ContactUs = () => {
  const handleOnSubmit = (e) => {
    e.preventDefault();

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, e.target)
      .then((result) => {
        console.log(result.text);
        alert("Message was sent successfully");
        e.target.reset();
      })
      .catch((error) => {
        console.log(error.text);
        alert("Error occurred");
      });
  };

  return (
    <div className='contact-container mb-5 mt-5'>
    <h3 className='mb-5'>KONTAKTA OSS</h3>
    <Form onSubmit={handleOnSubmit} className="contact-form mx-auto mt-5">
 <Form.Group className="form_control1 mb-3" controlId="contactus ">
  <Form.Control className="rounded_text mb-3" type="name" id="name" name="from_name" required placeholder="Name" />
  <Form.Control className="rounded_text" type="email" id="email" name="user_email" required placeholder="name@example.com" />
</Form.Group>
      <Form.Group className="mb-3 form_control1">
        <Form.Control
          className="rounded_text "
          as="textarea"
          type="message"
          rows={6}
          cols={10}
          id="message"
          name="message"
          required
          placeholder="Please write a message"
        />
        <div className="text-left">
          <Button variant="secondary" type="submit" className="rounded mt-3">
            Submit
          </Button>
        </div>
      </Form.Group>
    </Form>
    </div>
  );
};

export default ContactUs;
